<div *adaptLoading="isLoading">
    <dx-chart [hidden]="data.length === 0"
              [dataSource]="data"
              title="Career Valuation timeline"
              [pathModified]="true"
              (onInitialized)="onInitialized($event)">
        <!-- Options -->
        <dxo-chart-size [height]="height"> </dxo-chart-size>
        <dxo-chart-argument-axis>
            <dxo-chart-label alignment="right"
                             format="monthAndYear"
                             overlappingBehavior="rotate"
                             [rotationAngle]="-45"> </dxo-chart-label>
        </dxo-chart-argument-axis>
        <dxo-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customiseTooltip"></dxo-chart-tooltip>
        <dxo-chart-common-series-settings argumentField="date"
                                          type="stackedarea"></dxo-chart-common-series-settings>
        <dxo-chart-margin [bottom]="50"></dxo-chart-margin>
        <dxo-chart-legend [visible]="true"></dxo-chart-legend>
        <dxo-chart-loading-indicator [enabled]="true"></dxo-chart-loading-indicator>

        <!-- Series -->
        @if (this.filterParameters?.category1) {
            <dxi-chart-series valueField="category1Count"
                              [name]="careerValuationUiService.valueStates[0].state"
                              [color]="careerValuationUiService.valueStates[0].fgColor"></dxi-chart-series>
        }

        @if (this.filterParameters?.category2) {
            <dxi-chart-series valueField="category2Count"
                              [name]="careerValuationUiService.valueStates[1].state"
                              [color]="careerValuationUiService.valueStates[1].fgColor"></dxi-chart-series>
        }

        @if (this.filterParameters?.category3) {
            <dxi-chart-series valueField="category3Count"
                              [name]="careerValuationUiService.valueStates[2].state"
                              [color]="careerValuationUiService.valueStates[2].fgColor"></dxi-chart-series>
        }

        @if (this.filterParameters?.category4) {
            <dxi-chart-series valueField="category4Count"
                              [name]="careerValuationUiService.valueStates[3].state"
                              [color]="careerValuationUiService.valueStates[3].fgColor"></dxi-chart-series>
        }
    </dx-chart>

    @if (data.length === 0) {
        <div>
            <adapt-no-cultural-measurement label="Career Valuations"></adapt-no-cultural-measurement>
        </div>
    }
</div>
